"use client"

import { useQuery } from "@tanstack/react-query"
import { getAiDisclosureSummaryAction, getAiDisclosureHistoryAction, getAiDisclosureDetailsAction } from "@/server-actions/ai-disclosure-settings"
import { usePermissions } from "@/hooks/use-permissions"
import { useAuth } from "@/hooks/use-auth"
import { TENANTS_PERMISSIONS } from "@/lib/auth/permissions.constants"

export function useAiDisclosureSummaryQuery(from: string, to: string) {
  const options = useReportQueryOptions("summary", from, to)
  return useQuery({ ...options, queryFn: async () => {
    const result = await getAiDisclosureSummaryAction({ from, to })
    if ("status" in result) throw new Error(result.errorMessage)
    return result
  } })
}

export function useAiDisclosureHistoryQuery(from: string, to: string) {
  const options = useReportQueryOptions("history", from, to)
  return useQuery({ ...options, queryFn: async () => {
    const result = await getAiDisclosureHistoryAction({ from, to })
    if ("status" in result) throw new Error(result.errorMessage)
    return result
  } })
}

export function useAiDisclosureDetailsQuery(from: string, to: string, cursor?: string) {
  const options = useReportQueryOptions("details", from, to)
  return useQuery({ ...options, queryKey: [...options.queryKey, cursor], queryFn: async () => {
    const result = await getAiDisclosureDetailsAction({ from, to, cursor })
    if ("status" in result) throw new Error(result.errorMessage)
    return result
  } })
}

function useReportQueryOptions(section: string, from: string, to: string) {
  const { activeTenantId, can } = usePermissions()
  const { isAuthenticated } = useAuth()
  return {
    queryKey: ["organization", "ai-disclosure-report", section, activeTenantId, from, to],
    enabled: isAuthenticated && Boolean(activeTenantId) && can([TENANTS_PERMISSIONS.VIEW_OWN, TENANTS_PERMISSIONS.EDIT_OWN]),
    staleTime: 60_000,
  }
}
